// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.fermentation_alert_channel_enum */
var FermentationAlertChannelEnum;
(function (FermentationAlertChannelEnum) {
    FermentationAlertChannelEnum["SMS"] = "SMS";
    FermentationAlertChannelEnum["VOICE"] = "VOICE";
})(FermentationAlertChannelEnum || (FermentationAlertChannelEnum = {}));
;
export default FermentationAlertChannelEnum;
/** Zod schema for fermentation_alert_channel_enum */
export const fermentationAlertChannelEnum = z.nativeEnum(FermentationAlertChannelEnum);
//# sourceMappingURL=FermentationAlertChannelEnum.js.map